var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"week-statistics-tip"},[_c('span',{staticClass:"tip-text"},[_vm._v("注：本周日更新上周日至本周六数据")])])
}]

export { render, staticRenderFns }